module.exports  = [
    {
        moduleName: 'Lead',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Deal',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
        },      
      {
        moduleName: 'Client',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Company',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Quote',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Walkthrough',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },

      //operations
      {
        moduleName: 'Site',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Inspection',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Survey',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Map',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      //Finance modules   
      {
        moduleName: 'Sales Order',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Invoice',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Vendor',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Purchase Order',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Bill',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Inventory',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      //HRM
      {
        moduleName: 'Employee',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
      {
        moduleName: 'Attendance',
          fullAccess: false,
          add: false,
          viewAll: false,
          modifyAll: false,
          delete: false,
      },
]



